import { render } from "./ExpectationsFramework.vue?vue&type=template&id=dfd8e12a&scoped=true"
import script from "./ExpectationsFramework.vue?vue&type=script&lang=js"
export * from "./ExpectationsFramework.vue?vue&type=script&lang=js"

import "./ExpectationsFramework.vue?vue&type=style&index=0&id=dfd8e12a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd8e12a"]])

export default __exports__